import { cn } from "@/lib/utils";

interface Properties {
  title: string;
  className?: string;
  children?: any;
}

/**
 * Betitelte Inhalts-Karte der Settings-/Admin-Panels. Der Titel trägt die
 * Kundenfarbe über die CSS-Variable aus Theme.tsx (Fallback: foreground),
 * damit hier kein Inline-Style und kein useCustomerTheme-Re-Render nötig ist.
 */
export default function Section(properties: Properties) {
  return (
    <section
      className={cn(
        "relative flex min-w-0 flex-col rounded-xl border bg-card p-4 text-card-foreground shadow-sm",
        properties.className
      )}
    >
      <h2 className="text-base font-semibold leading-tight text-[color:var(--customer-primary-dark,hsl(var(--foreground)))]">
        {properties.title}
      </h2>
      <div className="mt-3 flex min-w-0 flex-1 flex-col">
        {properties.children}
      </div>
    </section>
  );
}
